<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <info-section class="mt-5"
                            type="danger"
                            :title="$t('notFound.marketingTitle')"
                            :description="$t('notFound.marketingDescription')"
                            icon="nc-icon nc-alert-circle-i">
                <h2 class="text-white mt-3">{{ $t('notFound.pageTitle') }}</h2>
                <small class="text-white">{{ $t('notFound.pageDescription') }}
                  <br>
                  <br>
                  {{ $t('notFound.navigateBack') }} <router-link to="/">{{ $t('notFound.mainPage') }}</router-link>
                </small>
              </info-section>
            </div>
          </div>
        </div>
        <div class="full-page-background" style="background-image: url(static/img/background/404.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {Card, Checkbox, Button, InfoSection} from 'src/components/UIComponents';
  export default {
    components: {
      Card,
      InfoSection,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
